import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import { CustomBaseStore } from '@city/const';
import { SdvorInputSearchModalComponent } from '@sdvor/shared/ui/v2';
import { BehaviorSubject, debounceTime, map, tap } from 'rxjs';

@Component({
  selector: 'sd-city-search',
  imports: [SdvorInputSearchModalComponent, AsyncPipe],
  templateUrl: './city-search.component.html',
  styleUrls: ['./city-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CitySearchComponent implements OnInit {
  // Плейсхолдер инпута
  placeholder = 'поиск';

  // Внутренний контрол инпута
  inputControl = new FormControl();

  // Показывать лоадер
  isLoading$ = new BehaviorSubject<boolean>(false);

  // Полученный список городов
  @Input() baseStores: CustomBaseStore[];

  // Фильтрация городов
  @Output() filterBaseStores = new EventEmitter<CustomBaseStore[]>();
  @Output() selectBaseStore = new EventEmitter<string>();

  constructor(private destroyRef: DestroyRef) {}

  ngOnInit(): void {
    this.inputControl.valueChanges
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        tap(() => this.isLoading$.next(true)),
        debounceTime(600),
        map((value) => {
          return value;
        }),
      )
      .subscribe((value) => {
        this.filterBaseStores.emit(this.filterStores(value && value.length >= 2 ? value : ''));
        this.isLoading$.next(false);
      });
  }

  // Очистить поисковую строку
  clear(): void {
    this.inputControl.patchValue('');
    this.filterBaseStores.emit(this.baseStores);
  }

  // Клик enter
  onEnterSearchInput(): void {
    if (!this.inputControl.value || this.inputControl.value.length < 2) {
      return;
    }

    const cities = this.filterStores(this.inputControl.value);

    if (cities.length) {
      this.clear();
      this.selectBaseStore.emit(cities[0].code);
    }
  }

  // Форматирование текста
  private formatSearchPhrase(value: string): string {
    return value.trim().toLowerCase();
  }

  // Фильтрация городов
  private filterStores(value: string): CustomBaseStore[] {
    return this.baseStores.filter((store) => store.name.toLowerCase().includes(this.formatSearchPhrase(value || '')));
  }
}
